import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@auth/index';
import { SflBaseComponent } from '../sfl-base/sfl-base.component';

@Component({
  selector: 'app-navigation',
  template: ''
})
export class NavigationComponent extends SflBaseComponent implements OnInit {
  constructor(private readonly auth: AuthService, private readonly router: Router) {
    super();
  }

  ngOnInit(): void {
    this.navigateTo();
  }

  async navigateTo() {
    const route = await this.auth.getLandingPageRoute();
    this.router.navigateByUrl(route);
  }

  navigateTOProject(): void {
    this.router.navigateByUrl(this.appRoutes.MANAGE_PROJECT);
  }
}
